import { baseGet, basePost } from "@/utils/api/base";
import apiEndPointList from "../constant/apiEndPointsList";
import { getSceneById } from "../../data/mockData";

export const sceneServices = {
    getPreviousSceneBySceneName: async ({sceneName, id_path, lang ='vn'}: {sceneName: string, id_path: string, lang?: string}) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.scene.GET_PREVIOUS_SCENE_BY_SCENE_NAME(sceneName, id_path, lang),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi next scene");
        }
        return response?.data;
    },

    getNextSceneBySceneName: async ({sceneName, id_path, lang ='vn'}: {sceneName: string, id_path: string, lang?: string}) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.scene.GET_NEXT_SCENE_BY_SCENE_NAME(sceneName, id_path, lang),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi next scene");
        }
        return response?.data;
    },


    // getAudioBySceneName: async ({scene_name, id_path, lang ='vn'}: {scene_name: string, id_path: string, lang?: string}) => {
    //     let response: { data?: any } | null = null;
    //     try {
    //         response = await baseGet({
    //             endpoint: apiEndPointList.scene.GET_NEXT_SCENE_BY_SCENE_NAME(scene_name, id_path, lang),
  


    getSceneBySceneName: async ({scene_name, id_path, language = 'vn', gender = "nu"}: {scene_name: string, id_path: string, language: string, gender: string}) => {
        let response: { data?: any } | null = null;
        try {
            let cleanSceneName = String(scene_name || '');
            const match = cleanSceneName.match(/^decodeURIComponent\(['"]?(.*?)['"]?\)$/);
            if (match) {
                try {
                    cleanSceneName = decodeURIComponent(match[1]);
                } catch {
                    cleanSceneName = match[1];
                }
            }
            if(cleanSceneName === "") {
                return {
                    "success": false,
                    "message": "Scene not found"
                }
            }
            response = await baseGet({
                endpoint: apiEndPointList.scene.GET_SCENE_BY_SCENE_NAME({ id_path, language, scene_name: cleanSceneName, gender }),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi next scene");
        }
        return response?.data;
    },

    getSceneBySceneIdFromHotspot: async ({scene_id, id_path, language = 'vn'}: {scene_id: string, id_path: string, language: string}) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.scene.GET_SCENE_BY_SCENE_ID_FROM_HOTSPOT({ id_path, language, scene_id }),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi next scene");
        }
        return response?.data;
    },

    

    getInformationForSceneAndGroupBySceneName: async ({scene_name, id_path, language = 'vn'}: {scene_name: string, id_path: string, language: string}) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.scene.GET_INFORMATION_FOR_SCENE_AND_GROUP_BY_SCENE_NAME({ id_path, language, scene_name }),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi next scene");
        }
        return response?.data;
    },
    

    getSceneById: async ({scene_id, id_path, language = 'vn', gender = "nu"}: {scene_id: string, id_path: string, language: string, gender: string}) => {
        let response: { data?: any } | null = null;

        try {
            response = await baseGet({
                endpoint: apiEndPointList.scene.GET_SCENE_BY_ID({ id_path, language, scene_id, gender }),
            });
            // console.log("Response from getSceneById:", response, apiEndPointList.scene.GET_SCENE_BY_ID({ id_path, language, scene_id, gender }));
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi next scene");
        }
        return response?.data;
    },

    incrementViewCount: async ({ scene_name, id_path }: { scene_name: string; id_path: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.scene.INCREMENT_SCENE_VIEW(scene_name, id_path),
            });
        } catch (err: any) {
            console.error("Error calling incrementViewCount API:", err);
        }
        return response?.data;
    }
    
};